<template>
  <div class="product-glance__row">
    <dt class="product-glance__category">
      <div class="product-glance__icon-container">
        <font-awesome-icon
          v-if="icon"
          aria-hidden="true"
          class="product-glance__icon"
          :icon="icon"></font-awesome-icon>
      </div>
      {{ category }}
    </dt>
    <dd v-for="(item, index) in values"
        :key="index"
        class="product-glance__value">
      {{ item }}
    </dd>
  </div>
</template>

<script>
export default {
  name: "ProductGlanceRow",
  props: {
    icon: {
      type: Array,
      default: null,
    },
    category: {
      type: String,
      default: null,
    },
    values: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style lang="less" scoped>
.product-glance {
  &__row {
    margin-bottom: 10px;
  }

  &__icon-container {
    min-width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    font-size: 1.5rem;
  }

  &__category {
    font-weight: 700;
    color: #555;
    display: flex;
  }

  &__value {
    color: #d71920;
    font-size: 1.13rem;
    font-weight: 700;
    margin-left: 100px;
    margin-bottom: 0;
  }
}
</style>
